import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ec2aca2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-textarea" }
const _hoisted_2 = ["id", "name", "maxLenght", "disabled"]
const _hoisted_3 = { class: "remaining-chars" }

import { ref, watch, withDefaults } from 'vue'

  interface Props {
    name: string
    charLimit?: number
    disabled?: boolean
    input?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    charLimit: { default: 500 },
    disabled: { type: Boolean, default: false },
    input: { default: '' }
  },
  emits: ['updateValue'],
  setup(__props: any, { emit }) {

const props = __props as { name: string, charLimit: number, disabled: boolean, input: string }

  

  

  let text = ref('')

  function updateText(event: Event & { target: HTMLInputElement }) {
    emit('updateValue', event.target.value)
  }

  watch(
    () => props.input,
    (value) => {
      text.value = value
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      id: __props.name,
      name: __props.name,
      maxLenght: __props.charLimit,
      disabled: __props.disabled,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(text) ? (text).value = $event : text = $event)),
      onInput: updateText
    }, null, 40, _hoisted_2), [
      [_vModelText, _unref(text)]
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('workouts.REMAINING_CHARS')) + ": " + _toDisplayString(_unref(text).length) + "/" + _toDisplayString(__props.charLimit), 1)
  ]))
}
}

})